import { ARTICLE_NUMBER_PER_PAGE, apiUri } from '../appConfig';

const guestList = (from = 0, count = ARTICLE_NUMBER_PER_PAGE) => (
	fetch(`${apiUri}/guest?from=${from}&take=${count}`)
		.then((res) => res.json())
		.catch((err) => console.error(err))
);

export default guestList;



// WEBPACK FOOTER //
// ./src/js/request/guestList.js